export default __webpack_public_path__ + "static/media/societe-01.0bca16a6.jpg";